import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.paymentDetailsHeading = {
    css: css`
        font-family: "Mulish";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
        background: ${getColor("common.backgroundContrast")};
        padding: 15px 20px;
        /* margin-bottom: 24px; */
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = mergeToNew(
    checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem,
    {
        css: css`
            padding: 25px 15px 30px 15px;
            flex-wrap: wrap;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 25px 15px 0px 15px;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        padding: 25px 15px 0px 15px;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        padding: 25px 15px 0px 15px;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])};
            [class^="FormFieldStyle"] {
                [class^="TypographyStyle"] {
                    font-weight: 700;
                }
            }
        `,
    },
);

checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem = mergeToNew(
    checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem,
    {
        css: css`
            padding: 25px 15px 30px 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 25px 15px 0px 15px;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        padding: 25px 15px 0px 15px;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        padding: 25px 15px 0px 15px;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}
            [class^="FormFieldStyle"] {
                [class^="TypographyStyle"] {
                    font-weight: 700;
                }
            }
        `,
    },
);

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardDetailsGridItem = mergeToNew(
    checkoutReviewAndSubmitPaymentDetailsStyles.creditCardDetailsGridItem,
    {
        css: css`
            padding: 0px 15px 0px 15px;
        `,
    },
);

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddressGridItem = mergeToNew(
    checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddressGridItem,
    {
        css: css`
            padding: 0px 15px 0px 15px;
        `,
    },
);
